import React, { useEffect, useState } from "react"
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import Loader from "react-loader-spinner"
import { withTranslation } from "react-i18next"
import { apiPostAnaliseIdDashboard } from "../../helpers/backend_helper"
import { getCompaniesValuesByOptions } from "../../helpers/utils"

const AnaliseIaModal = props => {
  const { isOpen, toggle, dashboardFilters } = props

  const [analise, setAnalise] = useState("")
  const [loading, setLoading] = useState(false)

  const formatarCampo = (analise) => {
    const parts = String(analise || "").split("**")
    // Ex: "a **b** c" -> ["a ", "b", " c"]
    return parts.map((part, index) =>
      index % 2 === 1 ? <strong key={index}>{part}</strong> : <React.Fragment key={index}>{part}</React.Fragment>
    )
  }

  function analisarDadosIA(forcarAtualizacao = false) {
    setLoading(true)

    const argumentos = {
      companiesId: getCompaniesValuesByOptions(dashboardFilters.companiesSelected),
      dataInicial: dashboardFilters.periodStart,
      dataFinal: dashboardFilters.periodEnd,
      indicadores: ["ticket_medio_pessoa", "ticket_medio_atendimento", "analise_canais", "analise_vendas_notas", "evolucao_vendas", "evolucao_canais"],
      withoutCache: forcarAtualizacao
    }

    apiPostAnaliseIdDashboard(argumentos)
      .then(result => {
        let campoFormatado = formatarCampo(result?.analise)
        setAnalise(campoFormatado)
        setLoading(false)
      })
      .catch(error => {
        setAnalise(error.response.data.error)
        setLoading(false)
      })
  }

  useEffect(() => {
    analisarDadosIA()
  }, [])

  return (<React.Fragment>
      {loading ?
        <div className="loader-container">
          <Loader type="ThreeDots" color="#556EE6" height={80} width={80} />
        </div> :
        <Modal
          isOpen={isOpen}
          role="dialog"
          autoFocus={true}
          centered={true}
          tabIndex="-1"
          scrollable={false}
          size="xl"
          toggle={toggle}
        >
          <div className="modal-content">

            <ModalHeader toggle={toggle}>
              <i className="bx bx-bulb me-2" aria-hidden="true" />
              {props.t("analise-ia.modal.title")}</ModalHeader>
            <ModalBody>
              <div className="outer">
                <div className="outer" style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                  {analise}
                </div>
              </div>

            </ModalBody>
            <ModalFooter>
              <Button type="button" color="secondary" className="me-2" onClick={() => analisarDadosIA(true)}>
                <i className="bx bx-revision align-middle font-size-16 me-2"></i>
                {props.t("analise-ia.modal.atualizar")}
              </Button>
              <Button type="button" color="primary" className="me-2" onClick={toggle}>
                {props.t("analise-ia.modal.close")}
              </Button>
            </ModalFooter>

          </div>
        </Modal>
      }
    </React.Fragment>
  )
}

AnaliseIaModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  dashboardFilters: PropTypes.any
}

const mapStatetoProps = state => {
  const { user } = state.Login
  return { user }
}

export default withTranslation()(connect(mapStatetoProps, {})(AnaliseIaModal))
